/* tslint:disable */
/* eslint-disable */
export enum CreditStatus {
  NotCredited = 'NOT_CREDITED',
  PartiallyCredited = 'PARTIALLY_CREDITED',
  FullyCredited = 'FULLY_CREDITED',
}
